import { FC } from "react"
import { Modal } from "@/ui/Modal"
import { OutlinedText } from "@/ui/OutlinedText"
import styles from "./DevToolsModal.module.scss"
import { EmulateEnvironmentSection } from "./ui/EmulateEnvironmentSection"
import { EmulatePhoneDeviceSection } from "./ui/EmulatePhoneDeviceSection"
import { OpenAnyModalSection } from "./ui/OpenAnyModalSection"
import { StorageSection } from "./ui/StorageSection"
import { TgInsetsSection } from "./ui/TgInsetsSection"

const modalType = "devTools"

export const DevToolsModal: FC = () => {
  return (
    <Modal.Center type={modalType}>
      <div className={styles.DevToolsModal_content}>
        <OutlinedText className={styles.DevToolsModal_title}>
          DEV MENU
        </OutlinedText>
        <div className={styles.DevToolsModal_sections}>
          <StorageSection />
          <TgInsetsSection />
          <EmulatePhoneDeviceSection />
          <EmulateEnvironmentSection />
          <OpenAnyModalSection />
        </div>
      </div>
    </Modal.Center>
  )
}
